var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"ready":_vm.ready,"processing":_vm.processing,"login":_vm.login,"withToken":_vm.withToken,"logout":_vm.logout,"authenticated":_vm.authenticated,"profile":_vm.profile})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }